import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import HeaderSection from "../navBar/components/headerSection";
import NavButtonsSection from "../navBar/components/navButtonsSection";
import ControlPanel from "../controlPanel/controlPanel";
import SearchBar from "../../pages/explore/components/searchBar/searchBar";
import QuestsButton from "../questsButton/questsButton";
import TotalPointsTag from "../TotalPointsTag/TotalPointsTag";
import AdminProfileIcon from "../adminProfileIcon/adminProfileIcon";
// import NotificationCard from "../../pages/notifications/components/notificationCard/notificationCard";
// import useNotifications from "../../pages/notifications/components/useNotifications/useNotifications";
// import NotificationBell from "../../pages/notifications/components/notificationBell/notificationBell";
import { Settings } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const GlobalHeader = ({ collapsed, setCollapsed, user }) => {
  const { username: urlUsername } = useParams();
  const username = urlUsername || localStorage.getItem("username");
  const navigate = useNavigate();

  const [showQuestTransition, setShowQuestTransition] = useState(false);
  const [showHardReloadFade, setShowHardReloadFade] = useState(false);
  const [bubblePosition, setBubblePosition] = useState({ top: 0, left: 0 });

  // const [showNotifications, setShowNotifications] = useState(false);
  const [showControlPanel, setShowControlPanel] = useState(false);
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
  
  // const {
  //   notifications,
  //   unreadCount,
  //   markAllAsRead,
  //   deleteNotification,
  //   loading,
  // } = useNotifications();

  useEffect(() => {
    const fetchUnreadMessages = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const res = await fetch(`${BACKEND_URL}/chats`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();
        const currentUserEmail = localStorage.getItem("userEmail");

        if (res.ok && data.chats) {
          let totalUnread = 0;
          for (const chat of data.chats) {
            const participants = Array.isArray(chat.participants)
              ? chat.participants
              : chat.participants.split(",").map((p) => p.trim());
            const iAmParticipant = participants.includes(currentUserEmail);
            const iAmSender = chat.lastSender === currentUserEmail;
            if (iAmParticipant && !iAmSender && chat.unreadCount > 0) {
              totalUnread += chat.unreadCount;
            }
          }
          setUnreadMessagesCount(totalUnread);
        }
      } catch (error) {
        console.error("❌ Error fetching unread messages:", error);
      }
    };

    fetchUnreadMessages();
    const interval = setInterval(fetchUnreadMessages, 10000);
    window.addEventListener("refresh-unread-count", fetchUnreadMessages);

    return () => {
      clearInterval(interval);
      window.removeEventListener("refresh-unread-count", fetchUnreadMessages);
    };
  }, []);

  const markMessagesAsRead = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      await fetch(`${BACKEND_URL}/chats/mark-as-read`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      setUnreadMessagesCount(0);
    } catch (error) {
      console.error("Error marking messages as read:", error);
    }
  };

  const handleNavigation = (label) => {
    if (label === "Explore") navigate(`/${username}/explore`);
    else if (label === "Create") navigate(`/${username}/create`);
    else if (label === "Messages") {
      if (unreadMessagesCount > 0) markMessagesAsRead();
      navigate(`/${username}/messages`);
    }
  };

  const handleBellClick = () => {
    navigate(`/${username}/notifications`);
  };

  return (
    <>
      <header className="sticky top-0 z-50 bg-white shadow-sm w-full">
        <div className="flex items-center justify-between px-4 py-2 h-[60px] w-full gap-4">

          {/* Left: Logo + Collapse Toggle */}
          <div className="flex items-center gap-2 shrink-0 z-10">
            <HeaderSection collapsed={collapsed} setCollapsed={setCollapsed} />
          </div>

          {/* Center: SearchBar */}
          <div className="z-10 flex justify-center flex-grow min-w-[120px] max-w-[500px] sm:max-w-[600px] mx-auto">
            <SearchBar />
          </div>

          {/* Right: Quests (mobile = icon only), Bell, Avatar */}
          <div className="flex items-center gap-4 shrink-0 z-10">

            {/* Quests Button - mobile (bubbles only) */}
            <div className="block sm:hidden scale-[0.8]">
              <QuestsButton
                onClick={(e) => {
                  const bubbleSize = 8;
                  const rect = e.currentTarget.getBoundingClientRect();
                  const left = rect.left + rect.width / 2;
                  const top = rect.top + rect.height / 2;
                  setBubblePosition({ top: top - bubbleSize / 2, left: left - bubbleSize / 2 });
                  setShowQuestTransition(true);
                  setTimeout(() => {
                    const username = localStorage.getItem("username");
                    window.location.href = `/${username}/quests`;
                  }, 700);
                }}
                hideText={true} // ✅ mobile = bubble only
              />
            </div>

            {/* Quests Button - desktop */}
            {/* <div className="hidden sm:flex items-center gap-3">
              <QuestsButton
                onClick={(e) => {
                  const bubbleSize = 8;
                  const rect = e.currentTarget.getBoundingClientRect();
                  const left = rect.left + rect.width / 2;
                  const top = rect.top + rect.height / 2;
                  setBubblePosition({ top: top - bubbleSize / 2, left: left - bubbleSize / 2 });
                  setShowQuestTransition(true);
                  setTimeout(() => {
                    const username = localStorage.getItem("username");
                    window.location.href = `/${username}/quests`;
                  }, 700);
                }}
              />
              <button
              onClick={() => {
                const username = localStorage.getItem("username");
                window.location.href = `/${username}/rewards`;
              }}
              className="ml-2 text-xs font-semibold"
              title="View your rewards"
            >
              <TotalPointsTag email={localStorage.getItem("userEmail")} />
            </button>



            </div> */}


            {/* Invites + Bell (desktop only) */}
            {/* <div className="hidden sm:flex items-center gap-1">
              <button
                onClick={() => navigate(`/${username}/invites`)}
                className="text-sm font-medium text-gray-800 hover:underline"
              >
                Invites
              </button>
              <NotificationBell unreadCount={unreadCount} onClick={handleBellClick} />
            </div> */}

            {/* Avatar: always visible */}
            <AdminProfileIcon user={user} onOpenSettings={() => setShowControlPanel(true)} />

          </div>
        </div>
      </header>

      {/* Expanding Bubble */}
      {showQuestTransition && (
        <div
          className="fixed w-6 h-6 bg-black z-[9999] animate-dropAndDissolve pointer-events-none"
          style={{
            top: `${bubblePosition.top}px`,
            left: `${bubblePosition.left}px`,
            transform: 'translate(-50%, 0)',
            borderRadius: '9999px',
          }}
        />
      )}


      {/* Fullscreen Fade after bubble */}
      {showHardReloadFade && (
        <div className="fixed inset-0 bg-black z-[9999] animate-fadeToBlack pointer-events-none" />
      )}


      {/* Notification Modal */}
      {/* {showNotifications && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[9999] px-4">
          <div className="bg-white rounded-xl p-6 w-full max-w-md max-h-[80vh] shadow-lg overflow-y-auto">
            <h3 className="text-lg font-semibold mb-4">Notifications</h3>
            {loading ? (
              <p>Loading...</p>
            ) : notifications.length === 0 ? (
              <p>No notifications</p>
            ) : (
              <div className="space-y-2">
                {notifications.map((noti) => (
                  <NotificationCard
                    key={noti.id}
                    notification={noti}
                    onDelete={deleteNotification}
                  />
                ))}
              </div>
            )}
            <button
              onClick={() => setShowNotifications(false)}
              className="mt-4 px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
            >
              Close
            </button>
          </div>
        </div>
      )} */}

      {/* Control Panel */}
      {showControlPanel && (
        <ControlPanel onClose={() => setShowControlPanel(false)} />
      )}
    </>
  );
};

export default GlobalHeader;